import { CallCenterPagination } from '../../domain/model/call_center_pagination';
import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface FetchCallCenterRepository {
    (pagination: Pagination): Promise<CallCenterPagination>
}

const fetchCallCenterRepository = (axios: AxiosInstance): FetchCallCenterRepository => async (pagination: Pagination) => {
    try {
        const response: AxiosResponse = await axios.get('/call-center', {
            params: pagination,
        })

        const callCenterPagination: CallCenterPagination = response.data
        return callCenterPagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchCallCenterRepository